import actionCreatorFactory from 'typescript-fsa';
import { Dispatch, Action } from 'redux';
import { getAPI, putAPI } from '../utils/APIUtils';

import { ActInfo, ActType, ApprovalActs, EditActInfo, EnforceInfo } from '../states/approvalState';
import { appActions } from '../actions/appAction';
import { EditStateAPIParam } from './editingActsAction';

const actionCreator = actionCreatorFactory();

export const approvalAction = {
	initActtype: actionCreator<ActType[]>('ACTION_INIT_ACTTYPE'),
	setApprovalError: actionCreator<boolean>('ACTION_SET_APPROVAL_ERROR'),
	getApprovalActs: actionCreator<ApprovalActs[]>('ACTIONS_GET_APPROVAL_ACTS'),
	getApprovalActsAsync: (accountid: string, id: string) => {
		return async (dispatch: Dispatch<Action>) => {
			try {
				const url = `/editing?accountid=${accountid}&id=${id}&state=done`;
				const json = await getAPI(url);

				const approvalActs: ApprovalActs[] = json.map((a,) => {
					return {
						id: a.id,
						approvalActTables: (() => {
							return a.editingActs.map((item) => {
								return {
									actId: item.actId,
									editingId: item.editingId,
									actNum: item.actNum,
									editActNum: item.editActNum,
									title: item.title,
									newTitle: item.newTitle,
									editState: item.editState,
									editType: item.editType,
									updateDate: item.updateDate,
									stepId: item.stepId,
									editActInfo: item.editActInfo || {
										publicationDate: '',
										editActType: '',
										editActNum: '',
										editActNumOptionViewFlag: false
									},
									actInfo: item.actInfo || {
										publicationDate: '',
										actType: '',
										actNum: '',
										actNumOptionViewFlag: false,
										expireDate: '',
										beforeEnactment: '',
										afterEnactment: '',
										preamble: '',
									},
									enforceInfo: item.enforceInfo,
									stepIdInfo: item.stepIdInfo || [1],
								};
							});
						})(),
					};
				});
				dispatch(approvalAction.getApprovalActs(approvalActs));

				{
					const url3 = `/settings/${accountid}/acttype`;
					const json3 = await getAPI(url3);
					dispatch(approvalAction.initActtype(json3.actType));
				};

			} catch (err) {
				console.log(err);
			}
			dispatch(appActions.setLoading(false));
		};
	},
	approvalAsync: (accountid: string, editingId: string, actId: string, idid: string, id: string, editType: string) => {
		return async (dispatch: Dispatch<Action>) => {
			try {
				const url = `/acts/${actId}/editings/${editingId}/enforce`;
				const options = {
					accountid: accountid,
					idid: idid,
					id: id,
					editType: editType,
				};
				await putAPI(url, options);

				await approvalAction.getApprovalActsAsync(accountid, id)(dispatch);

			} catch (err: any) {
				if (err.response && err.response.data) {
					const errorData = JSON.parse(JSON.stringify(err.response.data));
					if (errorData.type === 'ExclusiveLockError') {
						dispatch(approvalAction.setApprovalError(true));
					}
				} else {
					console.log(err);
				}
			}
			dispatch(appActions.setLoading(false));
		};
	},
	scrutinyAsync: (accountid: string, editingId: string, actId: string, idid: string, id: string, editType: string) => {
		return async (dispatch: Dispatch<Action>) => {
			try {
				const url = `/acts/${actId}/editings/${editingId}/enforce/scrutiny`;
				const options = {
					accountid: accountid,
					idid: idid,
					id: id,
					editType: editType,
				};
				await putAPI(url, options);

				await approvalAction.getApprovalActsAsync(accountid, id)(dispatch);

			} catch (err: any) {
				if (err.response && err.response.data) {
					const errorData = JSON.parse(JSON.stringify(err.response.data));
					if (errorData.type === 'ExclusiveLockError') {
						dispatch(approvalAction.setApprovalError(true));
					}
				} else {
					console.log(err);
				}
			}
			dispatch(appActions.setLoading(false));
		};
	},
	putEditStateAsync: (param: EditStateAPIParam, rejection: boolean) => {
		return async (dispatch: Dispatch<Action>) => {
			try {
				// 編集状態更新
				const url = `/acts/${param.actId}/editings/${param.editingId}/editstate`;
				const options = {
					accountid: param.accountId,
					id: param.id,
					editState: param.editState,
					editType: param.editType || '',
					rejection: rejection,
				};
				await putAPI(url, options);

				// 再取得
				await approvalAction.getApprovalActsAsync(param.accountId, param.id)(dispatch);
			} catch (err) {
				console.log(err);
			}
			dispatch(appActions.setLoading(false));
		}
	},
	commitEditActInfoAsync: (param: EditStateAPIParam, detail: EditActInfo) => {
		return async (dispatch: Dispatch<Action>) => {
			try {
				const url = `/acts/${param.actId}/editings/${param.editingId}/editactinfo`;
				const options = {
					accountid: param.accountId,
					id: param.id,
					editActInfo: JSON.parse(JSON.stringify(detail)),
				};
				await putAPI(url, options);

				// 再取得
				await approvalAction.getApprovalActsAsync(param.accountId, param.id)(dispatch);
			} catch (err) {
				console.log(err);
			}
			dispatch(appActions.setLoading(false));
		}
	},
	commitActInfoAsync: (param: EditStateAPIParam, detail: ActInfo) => {
		return async (dispatch: Dispatch<Action>) => {
			try {
				const url = `/acts/${param.actId}/editings/${param.editingId}/currentactinfo`;
				const options = {
					accountid: param.accountId,
					id: param.id,
					currentActInfo: JSON.parse(JSON.stringify(detail)),
				};
				await putAPI(url, options);

				// 再取得
				await approvalAction.getApprovalActsAsync(param.accountId, param.id)(dispatch);
			} catch (err) {
				console.log(err);
			}
			dispatch(appActions.setLoading(false));
		}
	},
	commitEnforceInfoAsync: (param: EditStateAPIParam, detail: EnforceInfo) => {
		return async (dispatch: Dispatch<Action>) => {
			try {
				// 呼び出しはstep1固定。enforceInfoに全段含まれている
				const url = `/acts/${param.actId}/editings/${param.editingId}/steps/${1}/enforceinfo`;
				const options = {
					accountid: param.accountId,
					id: param.id,
					enforceInfo: JSON.parse(JSON.stringify(detail)),
				};
				await putAPI(url, options);

				// 再取得
				await approvalAction.getApprovalActsAsync(param.accountId, param.id)(dispatch);
			} catch (err) {
				console.log(err);
			}
			dispatch(appActions.setLoading(false));
		}
	},
};
